import React from 'react';
import { useTranslation } from 'react-i18next';
import type { NavSectionConfig } from '@constants/navigation';
import NavItem from './NavItem';

interface NavSectionProps {
  section: NavSectionConfig;
  collapsed: boolean;
  onNavigate?: () => void;
}

const NavSection: React.FC<NavSectionProps> = ({ section, collapsed, onNavigate }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-0.5">
      {section.labelKey && !collapsed && (
        <p className="px-2.5 pb-1 pt-3 text-[11px] font-semibold uppercase tracking-[0.09em] text-muted-foreground">
          {t(section.labelKey)}
        </p>
      )}
      {section.items.map((item) => (
        <NavItem
          key={item.path}
          to={item.path}
          label={t(item.labelKey)}
          icon={item.icon}
          collapsed={collapsed}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
};

export default NavSection;
